import ntc from '../../images/ntc.png'
import ncell from '../../images/ncell.png'
import esewa from '../../images/esewa.png'
import simtv from '../../images/simtv.png'
import smartcell from '../../images/smartcell.png'
import dish from '../../images/dish.png'
import prabhu from '../../images/prabhutv.png'
import clear from '../../images/clear.png'
import worldlink from '../../images/worldlink.png'
import vianet from '../../images/vianet.png'
import classictech from '../../images/classictech.png'
import subisu from '../../images/subisu.png'
import kaspersky from '../../images/kaspersky.png'
import eset from '../../images/eset.png'
import wardwiz from '../../images/wardwiz.png'
import mcafee from '../../images/mcafee.png'
import nea from '../../images/nea.png'
import khanepaani from '../../images/khanapaani.png'
import utl from '../../images/utl.png'
import broadlink from '../../images/broadlink.png'
import ajod from '../../images/ajod.png'
import everest from '../../images/everest.png'
import general from '../../images/general.png'
import lumbini from '../../images/lumbini.png'
import nlg from '../../images/nlg.png'
import premier from '../../images/premier.png'
import sanima from '../../images/sanima.png'
import united from '../../images/united.png'
import shikhar from '../../images/shikhar.png'
import siddhartha from '../../images/siddhartha.png'


export const topup = [
    {
        title: "NTC Prepaid",
        image: ntc,
    },
    {
        title: "NTC Postpaid",
        image: ntc,
    },
    {
        title: "NCELL",
        image: ncell,
    },
    {
        title: "Smart Cell",
        image: smartcell,
    },
    {
        title: "NTC CDMA Pre-paid",
        image: ntc,
    },
    {
        title: "NTC CDMA Post-paid",
        image: ntc,
    },
    {
        title: "NTC PSTN (Landline)",
        image: ntc,
    },

]

export const television = [
    {
        title: "Dish Home",
        image: dish,
    },
    {
        title: "Sim TV",
        image: simtv,
    },
    {
        title: "Prabhu TV",
        image: prabhu,
    },
    {
        title: "Clear TV",
        image: clear,
    },
]

export const internet = [
    {
        title: "Worldlink",
        image: worldlink,
    },
    {
        title: "Vianet",
        image: vianet,
    },
    {
        title: "Subisu",
        image: subisu,
    },
    {
        title: "Classictech",
        image: classictech,
    },

]

export const antivirus = [
    {
        title: "Kaspersky",
        image: kaspersky,
    },
    {
        title: "ES ET",
        image: eset,
    },
    {
        title: "Wardwiz",
        image: wardwiz,
    },
    {
        title: "McAfee",
        image: mcafee,
    },

]

export const electricity = [
    {

        title: "AANBU KHAIRENI DC",
        image: nea
    },
    {

        title: "ACHHAM DC",
        image: nea
    },
    {

        title: "AMUWA DC",
        image: nea
    },
    {

        title: "ANARMANI DC",
        image: nea
    },
    {

        title: "ARGHAKHACHI DC",
        image: nea
    },
    {

        title: "ARUGHAT DC",
        image: nea
    },
    {

        title: "ATTARIYA DC",
        image: nea
    },
    {

        title: "BADEGAUN SDC",
        image: nea
    },
    {

        title: "BAGLUNG DC",
        image: nea
    },
    {

        title: "BAITADI DC",
        image: nea
    },
    {

        title: "BALAJU DC",
        image: nea
    },
    {

        title: "BANESHWOR DC",
        image: nea
    },
    {

        title: "BANSGADHI DC",
        image: nea
    },
    {

        title: "BARAHATHAWA DC",
        image: nea
    },
    {

        title: "BARDAGHAT SDC",
        image: nea
    },
    {

        title: "BARDIBAS DC",
        image: nea
    },
    {

        title: "Barhabise DC",
        image: nea
    },
    {

        title: "BELAURI DC",
        image: nea
    },
    {

        title: "BELBARI DC",
        image: nea
    },
    {

        title: "BELTAR DC",
        image: nea
    },
    {

        title: "BHADRAPUR DC",
        image: nea
    },
    {

        title: "BHAIRAHAWA DC",
        image: nea
    },
    {

        title: "BHAJANI DC",
        image: nea
    },
    {

        title: "BHAKTAPUR DC",
        image: nea
    },
    {

        title: "BHARATPUR DC",
        image: nea
    },
    {

        title: "BHIMAN DC",
        image: nea
    },
    {

        title: "BHOJPUR DC",
        image: nea
    },
    {

        title: "BIRATNAGAR DC",
        image: nea
    },
    {

        title: "BIRGUNJ DC",
        image: nea
    },
    {

        title: "BODEBARSAIEN DC",
        image: nea
    },
    {

        title: "BUDHABARE SDC",
        image: nea
    },
    {

        title: "BUDHANILKANTHA DC",
        image: nea
    },
    {

        title: "BUTWAL DC",
        image: nea
    },
    {

        title: "Chabahil DC",
        image: nea
    },
    {

        title: "CHAINPUR DC",
        image: nea
    },
    {

        title: "CHANAULI DC",
        image: nea
    },
    {

        title: "CHANDRANIGAPUR DC",
        image: nea
    },
    {

        title: "CHAPAGAUN SDC",
        image: nea
    },
    {

        title: "CHAUTARA DC",
        image: nea
    },
    {

        title: "DADELDHURA DC",
        image: nea
    },
    {

        title: "DAILEKH DC",
        image: nea
    },
    {

        title: "DAMAK DC",
        image: nea
    },
    {

        title: "DAMAULI DC",
        image: nea
    },
    {

        title: "DARCHULA DC",
        image: nea
    },
    {

        title: "DHADING DC",
        image: nea
    },
    {

        title: "DHANGADI DC",
        image: nea
    },
    {

        title: "DHANKUTA DC",
        image: nea
    },
    {

        title: "DHANUSHADHAM DC",
        image: nea
    },
    {

        title: "DHARAN DC",
        image: nea
    },
    {

        title: "DHARKE DC",
        image: nea
    },
    {

        title: "DHULABARI SDC",
        image: nea
    },
    {

        title: "DHUNCHE DC",
        image: nea
    },
    {

        title: "DIKTEL DC",
        image: nea
    },
    {

        title: "DOLAKHA DC",
        image: nea
    },
    {

        title: "DOTI DC",
        image: nea
    },
    {

        title: "DUHABI DC",
        image: nea
    },
    {

        title: "DUMRE DC",
        image: nea
    },
    {

        title: "FICKEL DC",
        image: nea
    },
    {

        title: "GAIDAKOT SDC",
        image: nea
    },
    {

        title: "GAIGHAT DC",
        image: nea
    },
    {

        title: "GAJURI DC",
        image: nea
    },
    {

        title: "GAURADAH DC",
        image: nea
    },
    {

        title: "GAUR DC",
        image: nea
    },
    {

        title: "GAUSALA DC",
        image: nea
    },
    {

        title: "GHORAHI DC",
        image: nea
    },
    {

        title: "GORKHA DC",
        image: nea
    },
    {

        title: "GULARIYA DC",
        image: nea
    },
    {

        title: "GULMI DC",
        image: nea
    },
    {

        title: "HANUMAN DC",
        image: nea
    },
    {

        title: "HETAUDA DC",
        image: nea
    },
    {

        title: "IILAM DC",
        image: nea
    },
    {

        title: "INARUWA DC",
        image: nea
    },
    {

        title: "ITAHARI DC",
        image: nea
    },
    {

        title: "JAHARE DC",
        image: nea
    },
    {

        title: "JAJARKOT DC",
        image: nea
    },
    {

        title: "JALESHOR DC",
        image: nea
    },
    {

        title: "JANAKPUR DC",
        image: nea
    },
    {

        title: "JIRI DC",
        image: nea
    },
    {

        title: "JOGBUDA DC",
        image: nea
    },
    {

        title: "JORPATI DC",
        image: nea
    },
    {

        title: "KALAIYA DC",
        image: nea
    },
    {

        title: "KALIKOT DC",
        image: nea
    },
    {

        title: "KANCHANPUR DC",
        image: nea
    },
    {

        title: "KATARI DC",
        image: nea
    },
    {

        title: "KAVRE DC",
        image: nea
    },
    {

        title: "KAWASOTI DC",
        image: nea
    },
    {

        title: "Khadbari DC",
        image: nea
    },
    {

        title: "khajura DC",
        image: nea
    },
    {

        title: "KHARIDHUNGA DC",
        image: nea
    },
    {

        title: "KIRTIPUR DC",
        image: nea
    },
    {

        title: "KNAGAR DC",
        image: nea
    },
    {

        title: "KOHALPUR DC",
        image: nea
    },
    {

        title: "KULESHOR DC",
        image: nea
    },
    {

        title: "LAGANKHEL DC",
        image: nea
    },
    {

        title: "LAHAN DC",
        image: nea
    },
    {

        title: "LALBANDI DC",
        image: nea
    },
    {

        title: "LAMAHI DC",
        image: nea
    },
    {

        title: "Lamjung DC",
        image: nea
    },
    {

        title: "LAMKI DC",
        image: nea
    },
    {

        title: "Lekhnath DC",
        image: nea
    },
    {

        title: "LUBHU SDC",
        image: nea
    },
    {

        title: "LUMBINI DC",
        image: nea
    },
    {

        title: "MAHARAJGUNJ DC",
        image: nea
    },
    {

        title: "MAHENDRANAGAR DC",
        image: nea
    },
    {

        title: "MAINAPOKHARI DC",
        image: nea
    },
    {

        title: "Majuwa DC",
        image: nea
    },
    {

        title: "MALANGWA DC",
        image: nea
    },
    {

        title: "MANGALSEN DC",
        image: nea
    },
    {

        title: "MANTHALI DC",
        image: nea
    },
    {

        title: "MAULAPUR DC",
        image: nea
    },
    {

        title: "MELAMCHI DC",
        image: nea
    },
    {

        title: "Mirchiya DC",
        image: nea
    },
    {

        title: "MIRMI DC",
        image: nea
    },
    {

        title: "MUDHE DC",
        image: nea
    },
    {

        title: "MYAGDI DC",
        image: nea
    },
    {

        title: "NAXAL DC",
        image: nea
    },
    {

        title: "NAYAMILL DC",
        image: nea
    },
    {

        title: "NEA : TAPLEJUNG DC",
        image: nea
    },
    {

        title: "NEPALGUNJ DC",
        image: nea
    },
    {

        title: "NIJGADH DC",
        image: nea
    },
    {

        title: "Nuwakot DC",
        image: nea
    },
    {

        title: "OKHALDHUNGA DC",
        image: nea
    },
    {

        title: "PALPA DC",
        image: nea
    },
    {

        title: "PALUNG DC",
        image: nea
    },
    {

        title: "PANAUTI DC",
        image: nea
    },
    {

        title: "PANCHKHAL DC",
        image: nea
    },
    {

        title: "PANCHTHAR DC",
        image: nea
    },
    {

        title: "PARASI DC",
        image: nea
    },
    {

        title: "PARBAT DC",
        image: nea
    },
    {

        title: "PASHUPATINAGAR DC",
        image: nea
    },
    {

        title: "PATAN DC",
        image: nea
    },
    {

        title: "POKHARA DC",
        image: nea
    },
    {


        title: "POKHARA GRAMIN SDC",
        image: nea
    },
    {

        title: "POKHARIYA DC",
        image: nea
    },
    {

        title: "PULCHOWK DC",
        image: nea
    },
    {

        title: "PYUTHAN DC",
        image: nea
    },
    {

        title: "RAJAPUR DC",
        image: nea
    },
    {

        title: "RAJBIRAJ DC",
        image: nea
    },
    {

        title: "RAMECHHAP DC",
        image: nea
    },
    {

        title: "RANGELI DC",
        image: nea
    },
    {

        title: "RANI SUB DC",
        image: nea
    },
    {

        title: "RATNAPARK DC",
        image: nea
    },
    {

        title: "RIDI DC",
        image: nea
    },
    {

        title: "ROLPA DC",
        image: nea
    },
    {

        title: "RUKUM DC",
        image: nea
    },
    {

        title: "SAKHUWA DC",
        image: nea
    },
    {

        title: "SALYAN DC",
        image: nea
    },
    {

        title: "SANISCHARE SDC",
        image: nea
    },
    {

        title: "SANKHU DC",
        image: nea
    },
    {

        title: "SILGADHI DC",
        image: nea
    },
    {

        title: "simara DC",
        image: nea
    },
    {

        title: "SIMRAUNGADH DC",
        image: nea
    },
    {

        title: "SINDHU DC",
        image: nea
    },
    {

        title: "SINDHULI DC",
        image: nea
    },
    {

        title: "SIRAHA DC",
        image: nea
    },
    {

        title: "SURAJPURA DC",
        image: nea
    },
    {

        title: "SURKHET DC",
        image: nea
    },
    {

        title: "SURUNGA DC",
        image: nea
    },
    {

        title: "SYANGJA DC",
        image: nea
    },
    {

        title: "TANDI DC",
        image: nea
    },
    {

        title: "TATOPANI DC",
        image: nea
    },
    {

        title: "TAULIHAWA DC",
        image: nea
    },
    {

        title: "TEHRATHUM DC",
        image: nea
    },
    {

        title: "THIMI DC",
        image: nea
    },
    {

        title: "TIKAPUR DC",
        image: nea
    },
    {

        title: "TRIVENI DC",
        image: nea
    },
    {

        title: "TULSIPUR DC",
        image: nea
    },
    {

        title: "TUMLINGTAR DC",
        image: nea
    },
    {

        title: "URLABARI DC",
        image: nea
    },
    {

        title: "VURIGAUN DC",
        image: nea
    },
    {

        title: "YADUKUWA DC",
        image: nea
    }

]

export const khanepani = [
    {
        title: "Aadarsha Khanepani",
        image: khanepaani
    },
    {
        title: "Aalapot",
        image: khanepaani
    },
    {
        title: "Adarsh Nagar",
        image: khanepaani
    },
    {

        title: "Agyauli",
        image: khanepaani
    },
    {

        title: "Amritpani",
        image: khanepaani
    },
    {
        title: "Amritpur",
        image: khanepaani
    },
    {

        title: "Anandaban Shankarnagar",
        image: khanepaani
    },
    {
        title: "Angareshwor",
        image: khanepaani
    },
    {

        title: "Argha Gramin",
        image: khanepaani
    },
    {

        title: "Attariya",
        image: khanepaani
    },
    {

        title: "Babiyachaur",
        image: khanepaani
    },
    {

        title: "Badera",
        image: khanepaani
    },
    {

        title: "Bahadurganj khanepaani",
        image: khanepaani
    },
    {


        title: "Baitadi Nagar khanepaani",
        image: khanepaani
    },
    {

        title: "Bakalghad (Gajedi -2)",
        image: khanepaani
    },
    {

        title: "Bandipur",
        image: khanepaani
    },
    {

        title: "Banepa",
        image: khanepaani
    },
    {

        title: "Bansgadhi",
        image: khanepaani
    },
    {

        title: "Bardaghat",
        image: khanepaani
    },
    {

        title: "Bardibas",
        image: khanepaani
    },
    {

        title: "Bargaduwa",
        image: khanepaani
    },
    {

        title: "Basha",
        image: khanepaani
    },
    {

        title: "Bayarghari",
        image: khanepaani
    },
    {

        title: "Belhi",
        image: khanepaani
    },
    {


        title: "Bhadgaun Karadi",
        image: khanepaani
    },
    {


        title: "Bhadrapur",
        image: khanepaani
    },
    {


        title: "Bharatpur",
        image: khanepaani
    },
    {


        title: "Bharatpur, Dang",
        image: khanepaani
    },
    {

        title: "Bhate Dhikur",
        image: khanepaani
    },
    {

        title: "Bhimad",
        image: khanepaani
    },
    {

        title: "Bhurigaun",
        image: khanepaani
    },
    {


        title: "Bindabasini Brihat",
        image: khanepaani
    },
    {


        title: "Biratnagar",
        image: khanepaani
    },
    {

        title: "Birgunj",
        image: khanepaani
    },
    {

        title: "Birtamod",
        image: khanepaani
    },
    {

        title: "Bishnudol",
        image: khanepaani
    },
    {

        title: "Butwal",
        image: khanepaani
    },
    {


        title: "Chainpur",
        image: khanepaani
    },
    {

        title: "Chandragadhi",
        image: khanepaani
    },
    {


        title: "Chandragadi Dosro",
        image: khanepaani
    },
    {


        title: "Chandranigahpur",
        image: khanepaani
    },
    {

        title: "Changathali",
        image: khanepaani
    },
    {

        title: "Charali",
        image: khanepaani
    },
    {


        title: "Chargaun khanepaani",
        image: khanepaani
    },
    {

        title: "Chhapnahala",
        image: khanepaani
    },
    {

        title: "Chhinchu khanepaani",
        image: khanepaani
    },
    {

        title: "Chundevi",
        image: khanepaani
    },
    {

        title: "Chunikhel",
        image: khanepaani
    },
    {

        title: "Damak",
        image: khanepaani
    },
    {

        title: "Damauli",
        image: khanepaani
    },
    {


        title: "Danapur",
        image: khanepaani
    },
    {


        title: "Danchhi, Bhardabas",
        image: khanepaani
    },
    {

        title: "Deurali khanepaani",
        image: khanepaani
    },
    {


        title: "Devchuli khanepaani",
        image: khanepaani
    },
    {


        title: "Devghat",
        image: khanepaani
    },
    {

        title: "Dhakeri",
        image: khanepaani
    },
    {


        title: "Dhangadhi",
        image: khanepaani
    },
    {

        title: "Dhankuta",
        image: khanepaani
    },
    {


        title: "Dhobidhunga",
        image: khanepaani
    },
    {

        title: "Dhulabari",
        image: khanepaani
    },
    {

        title: "Dhulikhel",
        image: khanepaani
    },
    {

        title: "Dudharaksha Devisthan",
        image: khanepaani
    },
    {

        title: "Duhabi",
        image: khanepaani
    },
    {

        title: "Dumse khanepaani",
        image: khanepaani
    },
    {


        title: "Fulbari",
        image: khanepaani
    },
    {

        title: "Gagalphedi khanepaani(4,5,6)",
        image: khanepaani
    },
    {

        title: "Gauradaha",
        image: khanepaani
    },
    {

        title: "Hemja, Pokhara",
        image: khanepaani
    },
    {

        title: "Hetauda",
        image: khanepaani
    },
    {

        title: "Itahari",
        image: khanepaani
    },
    {


        title: "Jagatpur Kerunga",
        image: khanepaani
    },
    {


        title: "Jaleshwor",
        image: khanepaani
    },
    {


        title: "Janakpur",
        image: khanepaani
    },
    {

        title: "Jhumka, Sunsari",
        image: khanepaani
    },
    {

        title: "Kahun, Pokhara",
        image: khanepaani
    },
    {

        title: "Kakarvitta",
        image: khanepaani
    },
    {


        title: "Kapasetar",
        image: khanepaani
    },
    {


        title: "Khalanga, Dadeldhura",
        image: khanepaani
    },
    {


        title: "Khanikhola Tapudada",
        image: khanepaani
    },
    {

        title: "Lahan",
        image: khanepaani
    },
    {


        title: "Mahendranagar(Mahakali)",
        image: khanepaani
    },
    {

        title: "Murgiya",
        image: khanepaani
    },
    {


        title: "Narayani Saha Lagani",
        image: khanepaani
    },
    {


        title: "Nepalgunj",
        image: khanepaani
    },
    {

        title: "NWSC Bhairahawa",
        image: khanepaani
    },
    {

        title: "Pardi, Pokhara",
        image: khanepaani
    },
    {

        title: "Pathari",
        image: khanepaani
    },
    {


        title: "Pathlaiya",
        image: khanepaani
    },
    {

        title: "Phidim",
        image: khanepaani
    },
    {

        title: "Pithuwa",
        image: khanepaani
    },
    {

        title: "Rajbiraj",
        image: khanepaani
    },
    {

        title: "Ramnagar Brihat",
        image: khanepaani
    },
    {

        title: "Raniganj",
        image: khanepaani
    },
    {

        title: "Thaiba",
        image: khanepaani
    },
    {

        title: "Tokha Brihat",
        image: khanepaani
    },
    {

        title: "Urlabari",
        image: khanepaani
    }
]

export const recharge = [
    {
        title: "NTC",
        image: ntc
    },
    {
        title: "NCELL",
        image: ncell
    },
    {
        title: "UTL",
        image: utl
    },
    {
        title: "Dish home",
        image: dish
    },
    {
        title: "Broadlink",
        image: broadlink
    }
]

export const insurance = [
    {
        title: "Ajod Insurance",
        image: ajod,
    },
    {
        title: "Everest Insurance",
        image: everest,
    },
    {
        title: "General Insurance",
        image: general,
    },
    {
        title: "Lumbini Insurance",
        image: lumbini,
    },
    {
        title: "NLG Insurance",
        image: nlg,
    },
    {
        title: "Premier Insurance",
        image: premier,
    },
    {
        title: "Sanima General",
        image: sanima,
    },
    {
        title: "Shikhar Insurance",
        image: shikhar,
    },
    {
        title: "Siddhartha Insurance",
        image: siddhartha,
    },
    {
        title: "United General",
        image: united,
    },

]